module.exports = __webpack_public_path__ + "img/lo22go.40dfe493.png";